<template>
  <div class="navbar">
    <ul>
      <li>
        <div class="order">1</div>
        <div class="ch">選擇運送方式</div>
        <div class="en">Shipping</div>
      </li>
      <li>
        <div class="order">2</div>
        <div class="ch">選擇付款方式</div>
        <div class="en">Payment</div>
      </li>
      <li>
        <div class="order">3</div>
        <div class="ch">付款完成</div>
        <div class="en">Order Complete</div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
.navbar
  background-color: #F4F4F4
  padding: 22px 0px
  ul
    list-style: none
    display: flex
    justify-content: space-around
    li
      width: 120px
      display: flex
      flex-direction: column
      justify-content: center
      align-items: center
      .order
        width: 45px
        height: 45px
        border-radius: 50%
        background-color: #22363F
        color: #FFFFFF
        line-height: 45px
        text-align: center
        margin-bottom: 10px
      .en,.ch
        color: #707070
        font-size: 14px
</style>
